import { gql } from '@/__generated__';

const FETCH_ORGANIZATIONS = gql(`#graphql
  query FetchOrganizations {
    organizations {
      id
      name
      website
      bussinessSector
      address
      phone
      phoneNumber
      photo
      dga_user
      dga_password
      verify_auth_orgs
      callingCode
      access
      created
      hasDebt
      status
      irrigations {
        id
        name
      }
      publicOrganization {
        id
        relativePageUrl
        devices(pagination: { limit: 9999 }) {
          nodes {
            id
            name
          }
          pageInfo {
            totalCount
          }
        }
      }
    }
  }
`);

export default FETCH_ORGANIZATIONS;
